import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import api from '../api';

const safeText = (value) => {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    return value.vi || value.name || value.title || '';
  }
  return '';
};

const getProductImage = (product) => {
  if (product.images && product.images.length > 0) {
    return api.imageUrl(product.images[0].url);
  }
  return 'https://via.placeholder.com/400x400?text=No+Image';
};

const getProductAlt = (product) => {
  if (product.images && product.images.length > 0 && product.images[0].altText) {
    return safeText(product.images[0].altText);
  }
  return safeText(product.name);
};

const formatPrice = (price) => {
  if (price == null || price === '' || Number(price) === 0) return 'Liên hệ';
  return new Intl.NumberFormat('vi-VN').format(price) + 'đ';
};

const HomeCategoryProducts = ({ categories, zaloLink, hiddenCategories = [] }) => {
  const [productsByCategory, setProductsByCategory] = useState({});
  const { addToCart } = useCart();

  useEffect(() => {
    if (!categories || categories.length === 0) return;

    const visibleCategories = categories.filter(cat => !hiddenCategories.includes(cat.slug));
    if (visibleCategories.length === 0) return;

    const fetchAll = async () => {
      const result = {};
      for (const cat of visibleCategories) {
        try {
          const data = await api.getProducts({ category: cat.slug, home: true });
          const items = Array.isArray(data) ? data : (data.data || data.items || []);
          result[cat.slug] = items;
        } catch (err) {
          console.error(`Failed to load products for ${cat.slug}:`, err);
          result[cat.slug] = [];
        }
      }
      setProductsByCategory(result);
    };

    fetchAll();
  }, [categories, hiddenCategories]);

  if (!categories || categories.length === 0) return null;

  const visibleCategories = categories.filter(cat => !hiddenCategories.includes(cat.slug));
  if (visibleCategories.length === 0) return null;

  return (
    <>
      {visibleCategories.map(cat => {
        const products = productsByCategory[cat.slug] || [];
        if (products.length === 0) return null;

        return (
          <section key={cat.id || cat.slug} className="category-products-section">
            <div className="container">
              <div className="section-header">
                <h2 className="section-title">{safeText(cat.name)}</h2>
                <Link to={`/products?category=${cat.slug}`} className="section-view-all">
                  Xem tất cả <i className="fas fa-arrow-right"></i>
                </Link>
              </div>

              <div className="products-grid products-grid-6">
                {products.map(product => (
                  <div key={product.id} className="product-card">
                    <Link 
                      to={product.slug ? `/san-pham/${product.slug}` : `/products/${product.id}`} 
                      className="product-image"
                    >
                      <img
                        src={getProductImage(product)}
                        alt={getProductAlt(product)}
                        loading="lazy"
                      />
                      {product.badge && <span className="product-badge">{safeText(product.badge)}</span>}
                    </Link>

                    <div className="product-info">
                      <div className="product-name-row">
                        <h3 className="product-name">
                          <Link to={product.slug ? `/san-pham/${product.slug}` : `/products/${product.id}`} className="product-title-link">
                            {safeText(product.name)}
                          </Link>
                        </h3>
                        <button 
                          className="btn-add-to-cart-quick" 
                          onClick={(e) => {
                            e.preventDefault();
                            addToCart(product);
                          }}
                          title="Thêm vào giỏ hàng"
                        >
                          <i className="fas fa-shopping-cart"></i>
                        </button>
                      </div>

                      <div className="product-rating">
                        <span className="rating-value">
                          {(product.rating || 0).toFixed(1)} ★
                        </span>
                        <span className="review-count">
                          ({product.reviewCount || 0})
                        </span>
                      </div>

                      <div className="product-price">
                        <span className="price-current">{formatPrice(product.price)}</span>
                        {product.originalPrice && (
                          <span className="price-original">{formatPrice(product.originalPrice)}</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        );
      })}
    </>
  );
};

export default HomeCategoryProducts;
